import config from 'config';

export const getSecretKey = (): string | null => {
  if (process.env.REACT_APP_SYNCBAK_SECRET_KEY) {
    return process.env.REACT_APP_SYNCBAK_SECRET_KEY;
  }
  const platform = config.platformName;
  if (platform === 'vizio') {
    return process.env.REACT_APP_SYNCBAK_SECRET_KEY_VIZIO;
  }
  if (platform === 'lg-webos') {
    return process.env.REACT_APP_SYNCBAK_SECRET_KEY_LG;
  }
  if (platform === 'samsung-tizen') {
    return process.env.REACT_APP_SYNCBAK_SECRET_KEY_SAMSUNG;
  }

  return null;
};
